<template>
  <div ref='container' class='kd-panel'>
    <listing-form
      v-if='editing'
      :courseId='courseId'
      :learningModule='learningModule'
      :modulables='modulables'
      :modules='modules'
      @cancel='cancel'
      @update='passUpdate'
      :id='`${_uid}-form`'
    />
    <div
      v-if='!editing'
      class='module-listing__row'
      ref='listing'
    >
      <div class="module-listing__handle"></div>
      <div class="module-listing__order">
        <i class="kf">
          <p class='typo__title order-circle'> {{ learningModule.order }} </p>
        </i>
      </div>
      <div class="module-listing__content">
        <p class='module-listing__title typo__body--reg'>{{ learningModule.title }}</p>
        <p class='typo__caption--reg'>{{ subtitle(learningModule) }}</p>
      </div>
      <div class="module-listing__actions">
        <a @click="showForm" class="action-btn edit kd-ibtn" href="javascript:;">
          <i class="kf kf-pencil"></i>
        </a>
        <a @click="destroy" class="action-btn delete kd-ibtn kd-ibtn--delete" href="javascript:;">
          <i class="kf kf-trashcan"></i>
        </a>
      </div>
    </div>
    <a class="inline-block-link typo__body--reg mt1 module-listing__add-module"
       href="javascript:;"
       @click='$emit("add")'
       v-if='index == modules.length - 1'
       >
      <i class="kf kf-plus"></i>
      {{Kadenze.I18n.t('learning_module.add_module')}}
    </a>
  </div>
</template>

<script>
import listingForm from '../form/form-vm.vue';

export default {
  props: {
    courseId: String,
    learningModule: Object,
    modulables: Object,
    modules: Array,
    index: Number,
  },
  data() {
    return {
      editing: false
    }
  },
  components: {
    listingForm
  },
  mounted() {
    if ( this.learningModule.open ) {
      this.$nextTick(() => this.showForm())
    }
  },
  methods: {
    subtitle(module) {
      if ( this.learningModule.activities ) {
        return `Activities: ` + this.learningModule.activities.length
      }

      return ""
    },
    passUpdate(data, shouldClose) {
      this.$emit('list-item-update', data, this.index)
      if ( shouldClose ) {
        this.hideForm();
      }
    },
    showForm() {
      const animHelper = $('.module-form__animation-helper')[this.index];
      if (!animHelper) {
        this.editing = true
        return;
      }
      const height = animHelper.getBoundingClientRect().height
      const timeline = new TimelineLite({
        onComplete: () => {
          this.editing = true;
          if ( this.$refs.container ) {
            this.$refs.container.style.height = 'auto';
          }
        }
      });

      timeline.to(this.$refs.container, .3, {maxWidth: 800, ease: Power2.easeInOut})
      timeline.to(this.$refs.listing, .3, {opacity: 0, ease: Power2.easeInOut}, "-=0.3")
      timeline.to(this.$refs.listing, .5, {height, ease: Power2.easeInOut}, "-=0.1")
    },
    cancel() {
      const callback = () => {
        this.hideForm().then(() => {
          if ( this.learningModule.id == undefined ) {
            this.destroy()
          }
        })
      }
      if ( !this.learningModule.id ) {
        Kadenze.UIUtil.confirmAction(Kadenze.I18n.t('modals.module_not_saved_dialoge'), callback)
      } else {
        callback()
      }
    },
    destroy() {
      const callback = () => this.$emit('delete', this.index);
      if ( this.learningModule.is_prerequisite ) {
        Kadenze.UIUtil.confirmAction('This module is listed as a prerequisite for another learning module. Are you sure you want to delete it?', callback);
      } else {
        callback();
      }
    },
    hideForm() {
      return new Promise((res, rej) => {
        const $form = $(`#${this._uid}-form`)
        const timeline = new TimelineLite({
          onComplete: () => {
            this.editing = false;
            if ( this.$refs.container ) {
              this.$refs.container.style.height = 'auto';
            }
            res();
          }
        });

        timeline.to($form, .3, { opacity: 0, ease: Power2.easeInOut })
        timeline.to(this.$refs.container, .3, {maxWidth: 600, ease: Power2.easeInOut})
        timeline.to(this.$refs.container, .5, {height: 54, ease: Power2.easeInOut})
        timeline.to($form, 0, { height: 0 })
      })
    },
  }
}
</script>
